import { Paper, Typography } from '@mui/material'
import I18n from 'i18n-js'

const RetailerSettingsUsers: React.FC = () => {
  return (
    <>
      <Typography variant="h6" gutterBottom>
        {I18n.t('retailerSettings.users.title')}
      </Typography>

      <Paper sx={{ padding: 2 }}>Retailer Settings Users page ...</Paper>
    </>
  )
}

export default RetailerSettingsUsers
